import React, { useContext, useEffect, useState } from "react";
import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { encode } from "base64-arraybuffer";
import { format } from "date-fns";
import { EndosoContext } from "pages/endoso/context";
import SuraSans from "assets/fonts/SuraSans/SuraSans-Regular.otf";
import SuraSansBold from "assets/fonts/SuraSans/SuraSans-Negrita.otf";

export const PdfPreview24 = () => {
  const { textoSalidaAlumnos24: data } = useContext(EndosoContext);
  const [pdfData, setPdfData] = useState(null);

  useEffect(() => {
    const createPdf = async () => {
      const pdfDoc = await PDFDocument.create();
      const page = pdfDoc.addPage([600, 680]);
      let regularFont;
      let boldFont;

      try {
        regularFont = await pdfDoc.embedFont(SuraSans);
        boldFont = await pdfDoc.embedFont(SuraSansBold);
      } catch (error) {
        console.error(
          "No se pudo cargar las fuentes personalizadas, usando Helvetica como respaldo.",
          error
        );

        regularFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
        boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
      }

      const imageResponse = await fetch(
        "https://images.prismic.io/imagessura/3c2b5aca-6973-423c-9d5d-c000308a1853_pud_agtclt_logoFooterMb_prod.png"
      );
      const imageArrayBuffer = await imageResponse.arrayBuffer();
      const base64LogoSura = encode(imageArrayBuffer);
      const logoSuraImage = await pdfDoc.embedPng(
        `data:image/png;base64,${base64LogoSura}`
      );

      page.drawImage(logoSuraImage, {
        x: 450,
        y: 610,
        width: 100,
        height: 40,
      });

      const textSure = "SEGUROS";

      page.drawText(textSure, {
        x: 350,
        y: 623,
        size: 14,
        font: boldFont,
        color: rgb(0, 51 / 255, 160 / 255),
      });

      const gerenteInfo = [
        "Seguros SURA, S.A. de C.V.",
        "Av. Insurgentes Sur 2475, pisos 22 y 23, col. Barrio Loreto,",
        "alcaldía Álvaro Obregón, C.P. 01090, Ciudad de México",
        "Tel. 55 5723 7999 y para reporte de siniestros: 800 911 7692",
      ];

      let startYInfo = 630;
      const lineHeightInfo = 12;

      gerenteInfo.forEach((line) => {
        page.drawText(line, {
          x: 50,
          y: startYInfo,
          size: 10,
          font: regularFont,
          color: rgb(0, 51 / 255, 160 / 255),
        });
        startYInfo -= lineHeightInfo;
      });

      const title = "Texto salida de alumnos";
      const titleSize = 20;
      const titleWidth = boldFont.widthOfTextAtSize(title, titleSize);
      const titlePositionX = (page.getWidth() - titleWidth) / 2;

      page.drawText(title, {
        x: titlePositionX,
        y: 500,
        size: titleSize,
        font: boldFont,
        color: rgb(0, 0, 0),
      });

      const fontSize = 14;
      const lineHeight = 16;
      const startX = 50;
      let startY = 450;

      const fechaSalida = data.salida ? format(data.salida, "dd/MM/yyyy") : "";
      const fechaRegreso = data.regreso
        ? format(data.regreso, "dd/MM/yyyy")
        : "";
      const horaSalida = data.horaSalida
        ? format(data.horaSalida, "HH:mm")
        : "";
      const horaRegreso = data.horaRegreso
        ? format(data.horaRegreso, "HH:mm")
        : "";

      const paragraphs = [
        `POR MEDIO DEL PRESENTE ENDOSO SE CUBRE LA SALIDA QUE TENDRÁN LOS SIGUIENTES ASEGURADOS A:`,
        `LUGAR: ${data.lugar}`,
        `UBICADO EN: ${data.ubicacion}`,
        `SALIDA ${fechaSalida} A LAS ${horaSalida}`,
        `REGRESO ${fechaRegreso} A LAS ${horaRegreso}`,
        `NOMBRE(S): LISTADO QUE OBRA EN PODER DE LA COMPAÑÍA (${data.numeroAsegurados} ASEGURADOS)`,
        `DEMAS TERMINOS Y CONDICIONES NO SUFREN MODIFICACIÓN ALGUNA`,
      ];

      paragraphs.forEach((paragraph) => {
        const words = paragraph.split(" ");
        let line = "";
        let lineWidth = 0;

        words.forEach((word, index) => {
          let testLine = line + word + " ";
          let testLineWidth = regularFont.widthOfTextAtSize(testLine, fontSize);

          if (testLineWidth > page.getWidth() - 2 * startX) {
            if (
              regularFont.widthOfTextAtSize(word, fontSize) >
              page.getWidth() - 2 * startX
            ) {
              let splitWord = word;
              while (
                regularFont.widthOfTextAtSize(splitWord, fontSize) >
                page.getWidth() - 2 * startX
              ) {
                let part = "";

                for (let i = 0; i < splitWord.length; i++) {
                  let testPart = part + splitWord[i];
                  if (
                    regularFont.widthOfTextAtSize(
                      line + testPart + "-",
                      fontSize
                    ) >
                    page.getWidth() - 2 * startX
                  ) {
                    break;
                  }
                  part = testPart;
                }

                page.drawText(line + part + "-", {
                  x: startX,
                  y: startY,
                  size: fontSize,
                  font: regularFont,
                  color: rgb(0, 0, 0),
                });

                splitWord = splitWord.slice(part.length);
                line = "";
                startY -= lineHeight;
              }
              word = splitWord;
              testLine = word + " ";
              testLineWidth = regularFont.widthOfTextAtSize(testLine, fontSize);
            }

            if (line.trim()) {
              const spaceCount = line.trim().split(" ").length - 1;
              const extraSpace =
                (page.getWidth() - 2 * startX - lineWidth) / (spaceCount || 1);

              let xPosition = startX;
              line
                .trim()
                .split(" ")
                .forEach((part, i) => {
                  page.drawText(part, {
                    x: xPosition,
                    y: startY,
                    size: fontSize,
                    font: regularFont,
                    color: rgb(0, 0, 0),
                  });
                  xPosition +=
                    regularFont.widthOfTextAtSize(part + " ", fontSize) +
                    extraSpace;
                });
              startY -= lineHeight;
            }

            line = word + " ";
            lineWidth = regularFont.widthOfTextAtSize(word + " ", fontSize);
          } else {
            line = testLine;
            lineWidth = testLineWidth;
          }
        });
        if (line.trim()) {
          page.drawText(line.trim(), {
            x: startX,
            y: startY,
            size: fontSize,
            font: regularFont,
            color: rgb(0, 0, 0),
          });

          startY -= lineHeight;
        }

        startY -= lineHeight;
      });

      page.drawText("Previo de endoso", {
        x: 80,
        y: 100,
        size: 76,
        font: regularFont,
        color: rgb(0, 0, 0),
        opacity: 0.1,
        rotate: degrees(35),
      });

      const pdfBytes = await pdfDoc.save();
      setPdfData(
        URL.createObjectURL(new Blob([pdfBytes], { type: "application/pdf" }))
      );
    };

    createPdf();
  }, [data]);

  return (
    <div>
      {pdfData && (
        <embed
          src={pdfData}
          type="application/pdf"
          width="100%"
          height="600px"
          style={{
            borderRadius: "10px",
            border: "none",
          }}
        />
      )}
    </div>
  );
};
